import React from 'react';
import PropTypes from 'prop-types';
import { SURVEY_INPUT_PROCESSING_STATES } from '../../Constants';
import './StatusBadge.scss';

const StatusBadge = ({ status }) => {
    const getStatusConfig = (status) => {
        switch (status) {
            case SURVEY_INPUT_PROCESSING_STATES.submitted:
                return {
                    className: 'status-pending',
                    label: 'Submitted'
                };
            case SURVEY_INPUT_PROCESSING_STATES.pendingLeadReview:
                return {
                    className: 'status-pending',
                    label: 'Pending Lead Review'
                };
            case SURVEY_INPUT_PROCESSING_STATES.readyForReview:
                return {
                    className: 'status-in-progress',
                    label: 'Ready For Review'
                };
            case SURVEY_INPUT_PROCESSING_STATES.inReview:
                return {
                    className: 'status-in-progress',
                    label: 'In Review'
                };
            case SURVEY_INPUT_PROCESSING_STATES.flaggedForAdminReview:
                return {
                    className: 'status-failed',
                    label: 'Flagged For Admin Review'
                };
            case SURVEY_INPUT_PROCESSING_STATES.flaggedForLeadReview:
                return {
                    className: 'status-failed',
                    label: 'Flagged For Lead Review'
                };
            case SURVEY_INPUT_PROCESSING_STATES.awaitingClientResponse:
                return {
                    className: 'status-pending',
                    label: 'Awaiting Client Response'
                };
            case SURVEY_INPUT_PROCESSING_STATES.readyForAdminQC:
                return {
                    className: 'status-in-progress',
                    label: 'Ready For Admin QC'
                };
            case SURVEY_INPUT_PROCESSING_STATES.reviewComplete:
                return {
                    className: 'status-completed',
                    label: 'Review Complete'
                };
            case SURVEY_INPUT_PROCESSING_STATES.accepted:
                return {
                    className: 'status-completed',
                    label: 'Accepted'
                };
            default:
                return {
                    className: 'status-unknown',
                    label: 'Unknown'
                };
        }
    };

    const { className, label } = getStatusConfig(status);

    return (
        <span className={`status-badge ${className}`}>
            {label}
        </span>
    );
};

StatusBadge.propTypes = {
    status: PropTypes.string.isRequired
};

export default StatusBadge; 